// Convert tailwind size class to pixels, default spacing scale: 1 unit = 4px
export function tailwindSizeToPixels(sizeClass: string, multiplier: number = 4): string | null {
  // Handle arbitrary sizes like size-[24px], w-[30px].
  // We are avoiding regex here for performance reasons,
  // given that could be called a lot in the app(such as in all the Avatar components)
  const left = sizeClass.indexOf("[");
  if (left !== -1) {
    const right = sizeClass.indexOf("]");
    if (right !== -1) return sizeClass.substring(left + 1, right);
  }

  // Handle standard sizes like size-4, w-6, h-8
  const prefixes = ["size-", "w-", "h-"];
  for (const prefix of prefixes) {
    if (sizeClass.startsWith(prefix)) {
      const sizeValue = parseFloat(sizeClass.slice(prefix.length));
      if (!isNaN(sizeValue)) {
        return `${sizeValue * multiplier}px`;
      }
    }
  }

  // Default to null if no match
  return null;
}
